/**
 * Square Footage Line Item Properties
 * 
 * This script intercepts both /cart/add.js and /cart/change.js requests
 * to attach/update the Details line item property with sqft calculations.
 */

(function() {
  'use strict';

  console.log('[SQFT] Combined interceptor loaded');

  /**
   * Format cents as currency string
   */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /**
   * Parse board length from option2 string (e.g., "6'" -> 6)
   */
  function parseBoardLength(boardLengthStr) {
    if (!boardLengthStr) return 0;
    const cleaned = boardLengthStr.replace(/[''′]/g, '').trim();
    return parseFloat(cleaned) || 0;
  }

  /**
   * Parse price from data attribute (e.g., "$281.37 USD" -> 28137 cents)
   */
  function parsePrice(priceStr) {
    if (!priceStr) return 0;
    const match = priceStr.match(/[\d,.]+/);
    if (!match) return 0;
    const dollars = parseFloat(match[0].replace(/,/g, '')) || 0;
    return Math.round(dollars * 100);
  }

  /**
   * Calculate the sqft info string
   */
  function calculateSqftString(quantity, boardLength, boardsPerUnit, sqftPerLf, soldPerBox, unitPriceCents) {
    console.info(`sqftPerLf=${sqftPerLf}; boardLength=${boardLength}`);
    if (sqftPerLf === 0 || boardLength === 0) {
      console.log('[SQFT] sqftPerLf or boardLength is 0, cannot calculate');
      return null;
    }

    const totalBoards = quantity * boardsPerUnit;
    const totalLinearFeet = totalBoards * boardLength;
    const totalSqFt = totalLinearFeet * sqftPerLf;
    const linePriceCents = unitPriceCents * quantity;
    const costPerSqFtCents = totalSqFt > 0 ? (linePriceCents / totalSqFt) : 0;

    const unitLabel = soldPerBox 
      ? (quantity === 1 ? 'box' : 'boxes')
      : (quantity === 1 ? 'board' : 'boards');

    const result = `${quantity} ${unitLabel}: ${totalSqFt.toFixed(2)} sq. ft. @ ${formatMoney(costPerSqFtCents)}/sq. ft.`;
    
    console.log('[SQFT] Calculated string:', result);
    return result;
  }

  // ============================================
  // ADD TO CART: Get data from .hidden-variant-info on product page
  // ============================================

  function getVariantDataFromProductPage(variantId) {
    console.log('[SQFT] Looking for variant on product page:', variantId);
    
    const el = document.querySelector(`.hidden-variant-info[data-variant-id="${variantId}"]`);
    if (!el) {
      console.log('[SQFT] No .hidden-variant-info element found for variant', variantId);
      return null;
    }

    const hasLengthAndTypeVariants = el.dataset.hasLengthAndTypeVariants === 'true';
    if (!hasLengthAndTypeVariants) {
      console.log('[SQFT] hasLengthAndTypeVariants is not true, skipping');
      return null;
    }
console.info(`[SQFT] > el=`, el);
    const data = {
      boardLength: parseBoardLength(el.dataset.boardLength),
      boardsPerUnit: parseInt(el.dataset.boardsPerUnit, 10) || 1,
      sqftPerLf: parseFloat(el.dataset.sqftPerLf) || 0,
      soldPerBox: el.dataset.soldPerBox === 'true',
      unitPriceCents: parsePrice(el.dataset.price)
    };

    console.log('[SQFT] Parsed variant data from product page:', data);
    return data;
  }

  // ============================================
  // CART CHANGE: Get data from .line-item__sqft-info in cart
  // ============================================

  function getSqftDataFromCart(lineKey) {
    console.log('[SQFT] Looking for line item in cart:', lineKey);
    
    const el = document.querySelector(`.line-item__sqft-info[data-line-key="${lineKey}"]`);
    if (!el) {
      console.log('[SQFT] No .line-item__sqft-info found for lineKey:', lineKey);
      return null;
    }

    console.info(`[SQFT] el=`, el);

    const data = {
      boardLength: parseFloat(el.dataset.boardLength) || 0,
      boardsPerUnit: parseFloat(el.dataset.boardsPerUnit) || 1,
      sqftPerLf: parseFloat(el.dataset.sqftPerLf) || 0,
      soldPerBox: el.dataset.soldPerBox === 'true',
      unitPriceCents: parseFloat(el.dataset.unitPrice) || 0
    };

    console.log('[SQFT] Parsed sqft data from cart:', data);
    return data;
  }

  // ============================================
  // FETCH INTERCEPTOR
  // ============================================

  const originalFetch = window.fetch;
  window.fetch = async function(url, options) {
    const urlStr = url ? url.toString() : '';

    // ---- INTERCEPT /cart/add.js ----
    if (urlStr.includes('/cart/add.js') && options && options.body) {
      console.log('[SQFT] Intercepted /cart/add.js request');
      
      try {
        let formData = options.body;
        
        // Handle FormData
        if (formData instanceof FormData) {
          const variantId = formData.get('id');
          const quantity = parseInt(formData.get('quantity'), 10) || 1;

          console.log('[SQFT] FormData - variantId:', variantId, 'quantity:', quantity);

          if (variantId) {
            const variantData = getVariantDataFromProductPage(variantId);
            
            if (variantData) {
              const sqftString = calculateSqftString(
                quantity,
                variantData.boardLength,
                variantData.boardsPerUnit,
                variantData.sqftPerLf,
                variantData.soldPerBox,
                variantData.unitPriceCents
              );
              
              if (sqftString) {
                formData.append('properties[Details]', sqftString);
                console.log('[SQFT] Added Details property to FormData');
              }
            }
          }
        }
        // Handle JSON body
        else if (typeof formData === 'string') {
          try {
            const jsonBody = JSON.parse(formData);
            const variantId = jsonBody.id || jsonBody.items?.[0]?.id;
            const quantity = jsonBody.quantity || jsonBody.items?.[0]?.quantity || 1;

            console.log('[SQFT] JSON - variantId:', variantId, 'quantity:', quantity);

            if (variantId) {
              const variantData = getVariantDataFromProductPage(variantId);
              
              if (variantData) {
                const sqftString = calculateSqftString(
                  quantity,
                  variantData.boardLength,
                  variantData.boardsPerUnit,
                  variantData.sqftPerLf,
                  variantData.soldPerBox,
                  variantData.unitPriceCents
                );
                
                if (sqftString) {
                  if (!jsonBody.properties) jsonBody.properties = {};
                  jsonBody.properties['Details'] = sqftString;
                  options.body = JSON.stringify(jsonBody);
                  console.log('[SQFT] Added Details property to JSON body');
                }
              }
            }
          } catch (e) {
            console.log('[SQFT] Not valid JSON:', e.message);
          }
        }
      } catch (error) {
        console.error('[SQFT] Error adding sqft properties:', error);
      }
    }

    // ---- INTERCEPT /cart/change.js ----
    if (urlStr.includes('/cart/change.js') && options && options.body) {
      console.log('[SQFT] Intercepted /cart/change.js request');
      
      try {
        let body;
        let isJson = false;
        
        if (typeof options.body === 'string') {
          body = JSON.parse(options.body);
          isJson = true;
        } else if (options.body instanceof FormData) {
          body = {
            id: options.body.get('id'),
            quantity: options.body.get('quantity')
          };
        }

        console.log('[SQFT] Change request body:', body);

        const lineKey = body.id;
        const newQuantity = parseInt(body.quantity, 10);

        // Skip if quantity is not being changed (properties-only update)
        if (body.quantity === undefined) {
          console.log('[SQFT] Skipping - no quantity in request');
          return originalFetch.apply(this, arguments);
        }

        // Get sqft data for this line item from the cart DOM
        const sqftData = getSqftDataFromCart(lineKey);
        
        if (sqftData && newQuantity > 0) {
          const sqftString = calculateSqftString(
            newQuantity,
            sqftData.boardLength,
            sqftData.boardsPerUnit,
            sqftData.sqftPerLf,
            sqftData.soldPerBox,
            sqftData.unitPriceCents
          );
          
          if (sqftString && isJson) {
            body.properties = body.properties || {};
            body.properties['Details'] = sqftString;
            options.body = JSON.stringify(body);
            console.log('[SQFT] Added Details property to change request');
          }
        }
      } catch (error) {
        console.error('[SQFT] Error processing cart change:', error);
      }
    }

    return originalFetch.apply(this, arguments);
  };

  console.log('[SQFT] Fetch interceptor installed');

})();
